// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"6ff3b5a5","453":"7cc6a38f","567":"86c1f8e7","623":"5be90562","839":"c6a48d9b","889":"6a8d9186"}[chunkId] + ".chunk.js";
};